module.exports = __webpack_public_path__ + "media/assets/icons/computer-icon-purple-d60fd1ac6ae7d2178975079124522334.png";